// extracted by mini-css-extract-plugin
module.exports = {"upgrade":"Upgrade_upgrade__sfrQi","row":"Upgrade_row__3i2sU","image":"Upgrade_image__339cH","text":"Upgrade_text__3r_AM","btn":"Upgrade_btn__1z44e","omega":"Upgrade_omega__21dhK"};